import { render, staticRenderFns } from "./NotificationCompanyEmployeeCreated.vue?vue&type=template&id=41628948&scoped=true&lang=pug&"
import script from "./NotificationCompanyEmployeeCreated.vue?vue&type=script&lang=js&"
export * from "./NotificationCompanyEmployeeCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41628948",
  null
  
)

export default component.exports